var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { TabGroup as BaseTabGroup, tabGroupClasses as baseTabGroupClasses, tabClasses, tabGroupIndicatorClasses, useTheme, } from "@vividtheory/minerva-lab";
import React from "react";
import { match } from "ts-pattern";
import { mergeSx } from "../system";
export const tabGroupClasses = baseTabGroupClasses;
export const TabGroup = (_a) => {
    var { square, rounded, sx } = _a, props = __rest(_a, ["square", "rounded", "sx"]);
    const theme = useTheme();
    const borderRadius = square || rounded
        ? match(props.variant)
            .with("default", () => theme.radius.full)
            .otherwise(() => theme.radius.default)
        : undefined;
    return (React.createElement(BaseTabGroup, Object.assign({}, props, { sx: mergeSx(Object.assign({ [`& .${tabGroupClasses["tab-container"]}`]: {
                gap: 1,
            } }, (borderRadius && {
            [`& .${tabClasses.default}`]: {
                borderRadius,
            },
            [`& .${tabClasses.filled}`]: {
                borderRadius,
            },
            [`& .${tabClasses.outline}`]: {
                borderRadius,
            },
            [`& .${tabClasses.tonal}`]: {
                borderRadius,
            },
            [`& .${tabGroupIndicatorClasses.root}`]: {
                [`&.${tabGroupIndicatorClasses.default}`]: {
                    borderRadius,
                },
                [`&.${tabGroupIndicatorClasses.filled}`]: {
                    borderRadius,
                },
                [`&.${tabGroupIndicatorClasses.outline}`]: {
                    borderRadius,
                },
                [`&.${tabGroupIndicatorClasses.tonal}`]: {
                    borderRadius,
                },
            },
        })), sx) })));
};
//# sourceMappingURL=TabGroup.js.map